// aiinsikt-report-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1a.report.pdfBackendUnavailable': 'PDF-backend er ikke tilgjengelig.',
  'r1a.report.pdfDownloadFailed': 'Kunne ikke laste ned PDF.',
  'r1a.report.openingPrint': 'Åpner utskrift …',
  'r1a.report.subtitleMonthly': 'Månedsrapport · resultat',
  'r1a.report.subtitleYearly': 'Årsrapport · resultat',
  'r1a.report.comparedWith': ' · sammenlignet med {period}',
  'r1a.report.chartTitle': 'Inntekt og kostnad per måned · {year}',
  'r1a.report.footnote': 'Rapportene er generert fra bokførte transaksjoner. Tidligere år er tilgjengelige så lenge regnskapet er ført. Sammenligningen viser samme periode året før.',
});
